var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "notificationGroup",
    { attrs: { group: "bottom", position: "bottom" } },
    [
      _c(
        "div",
        {
          staticClass:
            "inset-0 flex px-4 py-6 pointer-events-none p-6 items-start justify-end",
          staticStyle: { "pointer-events": "none" },
        },
        [
          _c(
            "div",
            { staticClass: "w-100", staticStyle: { "pointer-events": "auto" } },
            [
              _c("notification", {
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var notifications = ref.notifications
                      var close = ref.close
                      return _vm._l(notifications, function (notification) {
                        return _c(
                          "div",
                          {
                            key: notification.id,
                            staticClass:
                              "notification-container rounded-lg max-w-sm w-full mx-auto shadow-md overflow-hidden",
                            on: {
                              click: function ($event) {
                                return close(notification.id)
                              },
                            },
                          },
                          [
                            _c("button", { staticClass: "btn-close" }, [
                              _c(
                                "svg",
                                {
                                  attrs: {
                                    width: "14",
                                    height: "12",
                                    viewBox: "0 0 14 14",
                                    fill: "none",
                                    xmlns: "http://www.w3.org/2000/svg",
                                  },
                                },
                                [
                                  _c("path", {
                                    attrs: {
                                      "fill-rule": "evenodd",
                                      "clip-rule": "evenodd",
                                      d: "M12.9663 11.1996L8.43334 6.66667L12.9663 2.13371C13.4557 1.64432 13.4557 0.856436 12.9663 0.367044C12.4769 -0.122348 11.689 -0.122348 11.1996 0.367044L6.66667 4.9L2.13371 0.367044C1.64432 -0.122348 0.856436 -0.122348 0.367044 0.367044C-0.122348 0.856436 -0.122348 1.64432 0.367044 2.13371L4.9 6.66667L0.367044 11.1996C-0.122348 11.689 -0.122348 12.4769 0.367044 12.9663C0.856436 13.4557 1.64432 13.4557 2.13371 12.9663L6.66667 8.43334L11.1996 12.9663C11.689 13.4557 12.4769 13.4557 12.9663 12.9663C13.4522 12.4769 13.4522 11.6855 12.9663 11.1996Z",
                                      fill: "white",
                                    },
                                  }),
                                ]
                              ),
                            ]),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "d-flex mx-5 justify-content-center",
                              },
                              [
                                _c("span", { staticClass: "text-sm" }, [
                                  _vm._v(_vm._s(notification.text)),
                                ]),
                              ]
                            ),
                          ]
                        )
                      })
                    },
                  },
                ]),
              }),
            ],
            1
          ),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }